export default "__VITE_ASSET__CTvvJDLK__"